import { auditApi } from 'yxt-biz-pc/packages/api';

// 获取审核流程
export const getTaskDetail = (params) => {
  return auditApi.get('task/detail/auditing', {
    params
  });
};
